module.exports = __webpack_public_path__ + "static/media/devicestore.ffe294e1.svg";